"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPosition = getPosition;
exports.getPages = getPages;
function getPosition(totalPages, currentPage) {
  if (totalPages <= 5) return 'beginning';
  if (currentPage <= 3) return 'beginning';
  if (currentPage >= totalPages - 2) return 'end';
  return 'middle';
}
function getPages(totalPages, currentPage) {
  if (totalPages <= 5) {
    return Array.from({
      length: totalPages
    }, (_, i) => i + 1);
  }
  const position = getPosition(totalPages, currentPage);
  if (position === 'beginning') {
    return [1, 2, 3, 4, '...', totalPages];
  }
  if (position === 'end') {
    return [1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }
  // middle
  return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
}
